
import verifyManager from '@shein-risk/si_verify'
import { API_URL, ICON_TYPES, LLBS_COOKIE_NAME, METRIC_NAME_BLACK_FRIDAY, METRIC_NAME_CHECK_BACK } from '@/constants';
import { fetchWithRetries } from '@/utils';
import { setCookie } from '@/utils/setCookie';
import { reportDeferred } from '@/utils/metricHelper';

export default (data: any) => {
    return new Promise((resolve, reject) => {
        const { keep_store = true, baseURL, site_id, site_from, language, headers = {}, validate_type, validate_scene, validate_channel, validate_param, site_id_slim = '', twice_check = true, s_options = {} } = data
        verifyManager.init({
            baseURL,
            headers: () => headers,
            data: () => {
                return { site_id, site_from, language, site_id_slim }
            }
        })
        let options = {} as any
        if (!twice_check) {
            options = s_options
        } else {
            options = {
                validate_type: ICON_TYPES[validate_type],
                validate_scene,
                validate_channel,
                validate_param
            }
        }
        const callback = async (data) => {
            const { isSuccess, code } = data
            try {
                reportDeferred({
                    metric_name: METRIC_NAME_CHECK_BACK,
                    tags: { ...data, site_id, site_from, language, site_id_slim: site_id_slim || 'no_value' },
                    value: 1,
                    message: 'verifyManager check',
                    params: options
                })
            } catch (error) {
                console.error(error);
            }
            if (!twice_check) {
                resolve(data)
                return
            }
            if (code === '9404') {
                //黑五降级
                const _llbs = `K2${validate_type}_${Math.floor(Date.now() / 1000)}_PBnksDQyn9M_lUQcA51735iKGdUg8QmLcyrG50bkJ7uNB7NL0LS91pMtYT6N-AaWhsZyOKvd4EBh3A1p2OrOeO-c6XTxXAFdtOQdPeWX5hmNTmEHUkZvxmk5mqnhBpX9ZHahuFgLtIvVjnlPbK7QtWMic9VSLEejQLYssBaEnOuFu8tL0-nVnBBINNH138JgM2hcYqjqBRMlvOKrWKvG7rnYGVDoWnj1dqT0xjg8OLtu64YAOXUlXy3A6g-vBVs0IUSrc4Jz0UPxSR5l-Zan1vskNURDWyiba4JAUUVKBHC_7MbsvmlSxD-jhxZ5Y3t-2O8pjce47OhrBw9aJCcWMA`
                setCookie({ key: LLBS_COOKIE_NAME, value: _llbs, end: 3600 })
                await new Promise(r => setTimeout(r, window?.__limit_cookie_t || 2000));
                const _d = {
                    status: 'success',
                    code: '0',
                    llbs: _llbs
                }
                try {
                    reportDeferred({
                        metric_name: METRIC_NAME_BLACK_FRIDAY,
                        tags: { ..._d, type: 'flow_check' },
                        value: 1,
                        message: 'flow check black friday',
                        params: data
                    })
                } catch (error) {
                    console.error(error);
                }
                resolve(_d)
            } else {
                if (isSuccess) {
                    const params = {
                        challenge: '',
                        captcha_type: validate_type,
                        gRisk: '',
                        validate_scene,
                        validate_token: data?.info?.validate_token || '',
                        validate_channel
                    }
                    const d = await fetchWithRetries(`${baseURL}${API_URL.VALIDATION_ANTI_FLOW_CHECK}`, {
                        method: 'POST',
                        body: JSON.stringify(params),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then(response => response.json()).catch(err => err)
                    const risk_response = {
                        status: d.status == 0 ? 'success' : 'risk_error',
                        code: d.status,
                        llbs: d.llbs || ''
                    }
                    if (d.status == 0) {
                        if (keep_store) {
                            // 设置流量层挑战豁免cookie，有效期为网关拦截时间(cookie_duration)的2倍，防止正常用户的有效期小于网关设置的有效期
                            const timeout = parseInt(d.expire_time) || 0
                            setCookie({ key: LLBS_COOKIE_NAME, value: d.llbs, end: timeout })
                            await new Promise(r => setTimeout(r, window?.__limit_cookie_t || 2000));
                        }
                    }
                    try {
                        reportDeferred({
                            metric_name: METRIC_NAME_BLACK_FRIDAY,
                            tags: { ...d, type: 'flow_check' },
                            value: 1,
                            message: 'flow check usual',
                            params: data
                        })
                    } catch (error) {
                        console.error(error);
                    }
                    resolve(risk_response)
                } else {
                    resolve(data)
                }
            }
        }
        verifyManager.doVerify(options, callback).catch(data => {
            reject(data)
        })
    })
};
